<app-heading [title]="projectsTypeTitle" [button]="headingButton" [showToggle]="false"><span>{{project?.codeName}}</span></app-heading>
<div class="grid grid-nogutter">
    <div class="col-12 p-0">
        <p-tabView styleClass="full-w" [(activeIndex)]="activeTabIndex">

            <p-tabPanel header="Information">
                @if(activeTabIndex === 0){
                    <app-project-info [id]="projectId" [project]="project" (updateProjectState)="updateProjectState()" (changeTab)="changeTab($event)"></app-project-info>
                }
            </p-tabPanel>

            <p-tabPanel header="Documents" [disabled]="!project?.status">
                @if(activeTabIndex === 1){
                    <app-project-documents [project]="project" (updateProjectState)="updateProjectState()" (changeTab)="changeTab($event)"></app-project-documents>
                }
            </p-tabPanel>

            <p-tabPanel header="Roles" [disabled]="!project?.status">
                @if(activeTabIndex === 2){
                    <app-role [recievedRoleId]="roleId" (changeTab)="changeTab($event, true) " (sendOfferButtonFromRole)="changeTab($event, false)" (updateProjectState)="updateProjectStateAfterPublish()"></app-role>
                }
            </p-tabPanel> 

            <p-tabPanel header="Offers" [disabled]="!project?.status || project?.status === status.created">
                @if(activeTabIndex === 3){
                    <app-project-offers [id]="projectId" [isDefaultSelectedRole]="isDefaultSelectedRole" [project]="project" (updateProjectState)="updateProjectState()" (changeTab)="changeTab($event)"></app-project-offers>
                }
            </p-tabPanel>

            <p-tabPanel header="Review" [disabled]="!project?.status || project?.status === status.created">
                @if(activeTabIndex === 4){
                    <app-review [id]="projectId" [project]="project" (gotoRoleEditPage)="gotoRoleEditPage($event)" (changeTab)="gotoRoleEditPage($event)"></app-review>   
                }
            </p-tabPanel>
        </p-tabView>
    </div>
</div>
